import { Box, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

interface ModalPageTitleProps {
  title: string;
  subtitle?: string;
}

export default function ModalLabel(props: ModalPageTitleProps) {
  const { title, subtitle } = props;
  return (
    <Box sx={{ mt: 4, mb: 0.5 }}>
      <Typography
        variant="fieldHeader"
        sx={{
          fontSize: 14,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <>
          <Box sx={{ mt: '0.5' }} />
          <Box>
            <Trans>
              <Typography variant="subtitle2">{subtitle}</Typography>
            </Trans>
          </Box>
        </>
      )}
    </Box>
  );
}
